import type { MessageDescriptor } from 'react-intl';

export function getMessageDescriptorByTranslationKey(
  translationKey: string,
  messages: Record<string, MessageDescriptor>,
) {
  try {
    const messageDescriptor = messages[translationKey];
    if (messageDescriptor === undefined) {
      throw new Error('not a valid translation key');
    }
    return messageDescriptor;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    return null;
  }
}
